module.exports = __webpack_public_path__ + "img/couples_07_V.01a8e4fb.jpg";